export interface IVerb {
  infinitive: string;
  present: string;
  past: string;
  present_perfect: string;
  english: string;
}

export const data_array: IVerb[] = [
  {
    infinitive: "angre",
    present: "angrer",
    past: "angret, angra",
    present_perfect: "har angret, har angra",
    english: "regret",
  },
  {
    infinitive: "arbeide",
    present: "arbeider",
    past: "arbeidet",
    present_perfect: "har arbeidet",
    english: "work",
  },
  {
    infinitive: "arrangere",
    present: "arrangerer",
    past: "arrangerte",
    present_perfect: "har arrangert",
    english: "arrange",
  },
  {
    infinitive: "arve",
    present: "arver",
    past: "arvet, arva",
    present_perfect: "har arvet, har arva",
    english: "inherit",
  },
  {
    infinitive: "be",
    present: "ber",
    past: "ba",
    present_perfect: "har bedt",
    english: "ask, request",
  },
  {
    infinitive: "begrave",
    present: "begraver",
    past: "begravde",
    present_perfect: "har begravd",
    english: "bury",
  },
  {
    infinitive: "begynne",
    present: "begynner",
    past: "begynte",
    present_perfect: "har begynt",
    english: "begin",
  },
  {
    infinitive: "behandle",
    present: "behandler",
    past: "behandlet, behandla",
    present_perfect: "har behandlet, har behandla",
    english: "handle, manage",
  },
  {
    infinitive: "beholde",
    present: "beholder",
    past: "beholdt",
    present_perfect: "har beholdt",
    english: "retain, keep",
  },
  {
    infinitive: "bestemme",
    present: "bestemmer",
    past: "bestemte",
    present_perfect: "har bestemt",
    english: "decide",
  },
  {
    infinitive: "bestille",
    present: "bestiller",
    past: "bestilte",
    present_perfect: "har bestilt",
    english: "order",
  },
  {
    infinitive: "besøke",
    present: "besøker",
    past: "besøkte",
    present_perfect: "har besøkt",
    english: "visit",
  },
  {
    infinitive: "betale",
    present: "betaler",
    past: "betalte",
    present_perfect: "har betalt",
    english: "pay",
  },
  {
    infinitive: "betrakte",
    present: "betrakter",
    past: "betraktet, betrakta",
    present_perfect: "har betraktet, har betrakta",
    english: "view, regard",
  },
  {
    infinitive: "bety",
    present: "betyr",
    past: "betydde",
    present_perfect: "har betydd",
    english: "mean, signify",
  },
  {
    infinitive: "bevare",
    present: "bevarer",
    past: "bevarte",
    present_perfect: "har bevart",
    english: "save, maintain",
  },
  {
    infinitive: "bidra",
    present: "bidrar",
    past: "bidro",
    present_perfect: "har bidratt",
    english: "contribute",
  },
  {
    infinitive: "binde",
    present: "binder",
    past: "bandt",
    present_perfect: "har bundet",
    english: "bind",
  },
  {
    infinitive: "bite",
    present: "biter",
    past: "bet, beit",
    present_perfect: "har bitt",
    english: "bite",
  },
  {
    infinitive: "blande",
    present: "blander",
    past: "blandet, blanda",
    present_perfect: "har blandet, har blanda",
    english: "blend, mix",
  },
  {
    infinitive: "bli",
    present: "blir",
    past: "ble",
    present_perfect: "har blitt",
    english: "remain, become",
  },
  {
    infinitive: "bo",
    present: "bor",
    past: "bodde",
    present_perfect: "har bodd",
    english: "to live (location)",
  },
  {
    infinitive: "bre",
    present: "brer",
    past: "bredte",
    present_perfect: "har bredt",
    english: "spread",
  },
  {
    infinitive: "brekke",
    present: "brekker",
    past: "brakk",
    present_perfect: "har brukket",
    english: "break",
  },
  {
    infinitive: "brenne (opp)",
    present: "brenner (opp)",
    past: "brant (opp)",
    present_perfect: "har brant (opp)",
    english: "burn up",
  },
  {
    infinitive: "brenne",
    present: "brenner",
    past: "brente",
    present_perfect: "har brent",
    english: "set fire to",
  },
  {
    infinitive: "bringe",
    present: "bringer",
    past: "brakte",
    present_perfect: "har brakt",
    english: "bring",
  },
  {
    infinitive: "bruke",
    present: "bruker",
    past: "brukte",
    present_perfect: "har brukt",
    english: "use",
  },
  {
    infinitive: "bryte",
    present: "bryter",
    past: "brøt",
    present_perfect: "har brutt",
    english: "break",
  },
  {
    infinitive: "burde",
    present: "bør",
    past: "burde",
    present_perfect: "burdet",
    english: "should",
  },
  {
    infinitive: "by",
    present: "byr",
    past: "bydde, bød",
    present_perfect: "har bydd, har budt",
    english: "bid, command",
  },
  {
    infinitive: "bygge",
    present: "bygger",
    past: "bygde",
    present_perfect: "har bygd",
    english: "build",
  },
  {
    infinitive: "bære",
    present: "bærer",
    past: "bar",
    present_perfect: "har båret",
    english: "bear, carry",
  },
  {
    infinitive: "bøye",
    present: "bøyer",
    past: "bøyde",
    present_perfect: "har bøyd",
    english: "bend, conjugate",
  },
  {
    infinitive: "danne",
    present: "danner",
    past: "dannet, danna",
    present_perfect: "har dannet, har danna",
    english: "form, create",
  },
  {
    infinitive: "danse",
    present: "danser",
    past: "danset, dansa",
    present_perfect: "har danset, har dansa",
    english: "dance",
  },
  {
    infinitive: "dekke",
    present: "dekker",
    past: "dekket, dekka",
    present_perfect: "har dekket, har dekka",
    english: "cover, set",
  },
  {
    infinitive: "dele",
    present: "deler",
    past: "delte",
    present_perfect: "har delt",
    english: "divide, share",
  },
  {
    infinitive: "dra",
    present: "drar",
    past: "dro",
    present_perfect: "har dradd, har dratt",
    english: "drag, travel",
  },
  {
    infinitive: "drepe",
    present: "dreper",
    past: "drepte",
    present_perfect: "har drept",
    english: "kill",
  },
  {
    infinitive: "drikke",
    present: "drikker",
    past: "drakk",
    present_perfect: "har drukket",
    english: "drink",
  },
  {
    infinitive: "drive",
    present: "driver",
    past: "drev, dreiv",
    present_perfect: "har drevet",
    english: "operate, run",
  },
  {
    infinitive: "dyrke",
    present: "dyrker",
    past: "dyrket, dyrka",
    present_perfect: "har dyrket, har dyrka",
    english: "cultivate, raise",
  },
  {
    infinitive: "dø",
    present: "dør",
    past: "døde",
    present_perfect: "har dødd",
    english: "die",
  },
  {
    infinitive: "døpe",
    present: "døper",
    past: "døpte",
    present_perfect: "har døpt",
    english: "baptize",
  },
  {
    infinitive: "eie",
    present: "eier",
    past: "eide",
    present_perfect: "har eid",
    english: "own",
  },
  {
    infinitive: "elske",
    present: "elsker",
    past: "elsket",
    present_perfect: "har elsket",
    english: "love",
  },
  {
    infinitive: "ete",
    present: "eter",
    past: "åt",
    present_perfect: "har ett",
    english: "eat (slang)",
  },
  {
    infinitive: "falle",
    present: "faller",
    past: "falt",
    present_perfect: "har falt",
    english: "fall",
  },
  {
    infinitive: "fare",
    present: "farer",
    past: "for",
    present_perfect: "har faret",
    english: "fare, travel",
  },
  {
    infinitive: "finne",
    present: "finner",
    past: "fant",
    present_perfect: "har funnet",
    english: "find",
  },
  {
    infinitive: "finnes",
    present: "finnes, fins",
    past: "fantes",
    present_perfect: "har fantes",
    english: "be found, exist",
  },
  {
    infinitive: "fly",
    present: "flyr",
    past: "fløy",
    present_perfect: "har fløyet, har flydd",
    english: "fly",
  },
  {
    infinitive: "flyte",
    present: "flyter",
    past: "fløt",
    present_perfect: "har flytt",
    english: "flow",
  },
  {
    infinitive: "flytte",
    present: "flytter",
    past: "flyttet, flytta",
    present_perfect: "har flyttet, har flytta",
    english: "move",
  },
  {
    infinitive: "forberede",
    present: "forbereder",
    past: "forberedte",
    present_perfect: "har forberedt",
    english: "prepare",
  },
  {
    infinitive: "forby",
    present: "forbyr",
    past: "forbød",
    present_perfect: "har forbudt",
    english: "forbid, prohibit",
  },
  {
    infinitive: "forene",
    present: "forener",
    past: "forente",
    present_perfect: "har forent",
    english: "unite",
  },
  {
    infinitive: "foretrekke",
    present: "foretrekker",
    past: "foretrakk",
    present_perfect: "har foretrukket",
    english: "prefer",
  },
  {
    infinitive: "forklare",
    present: "forklarer",
    past: "forklarte",
    present_perfect: "har forklart",
    english: "explain",
  },
  {
    infinitive: "forlate",
    present: "forlater",
    past: "forlot",
    present_perfect: "har forlatt",
    english: "forsake, leave",
  },
  {
    infinitive: "forlove (seg)",
    present: "forlover (seg)",
    past: "forlovet (seg), forlova (seg)",
    present_perfect: "har forlovet (seg), har forlova (seg)",
    english: "become engaged",
  },
  {
    infinitive: "fornemme",
    present: "fornemmer",
    past: "fornemmet",
    present_perfect: "har fornemmet",
    english: "perceive, notice",
  },
  {
    infinitive: "forstå",
    present: "forstår",
    past: "forstod",
    present_perfect: "har forstått",
    english: "understand",
  },
  {
    infinitive: "forsvinne",
    present: "forsvinner",
    past: "forsvant",
    present_perfect: "har forsvunnet",
    english: "disappear",
  },
  {
    infinitive: "forsyne",
    present: "forsyner",
    past: "forsynte",
    present_perfect: "har forsynt",
    english: "supply, provide",
  },
  {
    infinitive: "fortelle",
    present: "forteller",
    past: "fortalte",
    present_perfect: "har fortalt",
    english: "tell, explain",
  },
  {
    infinitive: "fryse",
    present: "fryser",
    past: "frøs",
    present_perfect: "har frosset",
    english: "freeze, feel cold",
  },
  {
    infinitive: "følge",
    present: "følger",
    past: "fulgte",
    present_perfect: "har fulgt",
    english: "follow",
  },
  {
    infinitive: "få",
    present: "får",
    past: "fikk",
    present_perfect: "har fått",
    english: "get, receive",
  },
  {
    infinitive: "gi",
    present: "gir",
    past: "gav",
    present_perfect: "har gitt",
    english: "give",
  },
  {
    infinitive: "gidde",
    present: "gidder",
    past: "gadd",
    present_perfect: "har giddet",
    english: "manage to do something",
  },
  {
    infinitive: "gjelde",
    present: "gjelder",
    past: "gjaldt",
    present_perfect: "har gjeldt",
    english: "be in force, apply",
  },
  {
    infinitive: "gjøre",
    present: "gjør",
    past: "gjorde",
    present_perfect: "har gjort",
    english: "do",
  },
  {
    infinitive: "glede",
    present: "gleder",
    past: "gledet",
    present_perfect: "har gledet",
    english: "please, make happy",
  },
  {
    infinitive: "glemme",
    present: "glemmer",
    past: "glemte",
    present_perfect: "har glemt",
    english: "forget",
  },
  {
    infinitive: "gli",
    present: "glir",
    past: "glei",
    present_perfect: "har glidd",
    english: "glide",
  },
  {
    infinitive: "glimre",
    present: "glimrer",
    past: "glimret",
    present_perfect: "har glimret",
    english: "glisten",
  },
  {
    infinitive: "gnage",
    present: "gnager",
    past: "gnog, gnagde",
    present_perfect: "har gnagd",
    english: "gnaw",
  },
  {
    infinitive: "gni",
    present: "gnir",
    past: "gned, gnidde, gnei",
    present_perfect: "har gnidd",
    english: "rub",
  },
  {
    infinitive: "grave",
    present: "graver",
    past: "gravde",
    present_perfect: "har gravd",
    english: "dig",
  },
  {
    infinitive: "gre (seg)",
    present: "grer (seg)",
    past: "gredde (seg)",
    present_perfect: "har gredd (seg)",
    english: "comb one's hair",
  },
  {
    infinitive: "greie",
    present: "greier",
    past: "greide",
    present_perfect: "har greid",
    english: "manage, deal with",
  },
  {
    infinitive: "gripe",
    present: "griper",
    past: "grep, greip",
    present_perfect: "har grepet",
    english: "grasp, seize",
  },
  {
    infinitive: "gråte",
    present: "gråter",
    past: "gråt",
    present_perfect: "har grått",
    english: "cry, weep",
  },
  {
    infinitive: "gå",
    present: "går",
    past: "gikk",
    present_perfect: "har gått",
    english: "go, walk",
  },
  {
    infinitive: "ha",
    present: "har",
    past: "hadde",
    present_perfect: "har hatt",
    english: "have",
  },
  {
    infinitive: "handle",
    present: "handler",
    past: "handlet, handla",
    present_perfect: "har handlet, har handla",
    english: "act, shop, deal with",
  },
  {
    infinitive: "hende",
    present: "hender",
    past: "hendte",
    present_perfect: "har hendt",
    english: "happen",
  },
  {
    infinitive: "henge",
    present: "henger",
    past: "hang",
    present_perfect: "har hengt",
    english: "hang, droop",
  },
  {
    infinitive: "henge",
    present: "henger",
    past: "hengte",
    present_perfect: "har hengt",
    english: "hang up",
  },
  {
    infinitive: "hente",
    present: "henter",
    past: "hentet, henta",
    present_perfect: "har hentet, har henta",
    english: "fetch, bring",
  },
  {
    infinitive: "hete",
    present: "heter",
    past: "het",
    present_perfect: "har hett",
    english: "be named",
  },
  {
    infinitive: "heve",
    present: "hever",
    past: "hevet, hevde",
    present_perfect: "har hevet, har hevd",
    english: "raise",
  },
  {
    infinitive: "hilse",
    present: "hilser",
    past: "hilste",
    present_perfect: "har hilst",
    english: "greet",
  },
  {
    infinitive: "hjelpe",
    present: "hjelper",
    past: "hjalp",
    present_perfect: "har hjulpet",
    english: "help",
  },
  {
    infinitive: "holde",
    present: "holder",
    past: "holdt",
    present_perfect: "har holdt",
    english: "keep, hold",
  },
  {
    infinitive: "hoppe",
    present: "hopper",
    past: "hoppet, hoppa",
    present_perfect: "har hoppet, har hoppa",
    english: "hop",
  },
  {
    infinitive: "huske",
    present: "husker",
    past: "husket",
    present_perfect: "har husket",
    english: "remember",
  },
  {
    infinitive: "hvile",
    present: "hviler",
    past: "hvilte",
    present_perfect: "har hvilt",
    english: "rest",
  },
  {
    infinitive: "høre",
    present: "hører",
    past: "hørte",
    present_perfect: "har hørt",
    english: "hear",
  },
  {
    infinitive: "håndhilse",
    present: "håndhilser",
    past: "håndhilste",
    present_perfect: "har håndhilst",
    english: "shake hands",
  },
  {
    infinitive: "inkludere",
    present: "inkluderer",
    past: "inkluderte",
    present_perfect: "har inkludert",
    english: "include",
  },
  {
    infinitive: "innføre",
    present: "innfører",
    past: "innførte",
    present_perfect: "har innført",
    english: "introduce",
  },
  {
    infinitive: "interessere",
    present: "interesserer",
    past: "interesserte",
    present_perfect: "har interessert",
    english: "interest",
  },
  {
    infinitive: "invitere",
    present: "inviterer",
    past: "inviterte",
    present_perfect: "har invitert",
    english: "invite",
  },
  {
    infinitive: "jobbe",
    present: "jobber",
    past: "jobbet, jobba",
    present_perfect: "har jobbet, har jobba",
    english: "work",
  },
  {
    infinitive: "kjempe",
    present: "kjemper",
    past: "kjempet, kjempa",
    present_perfect: "har kjempet, har kjempa",
    english: "fight",
  },
  {
    infinitive: "kjenne",
    present: "kjenner",
    past: "kjente",
    present_perfect: "har kjent",
    english: "know (person, place)",
  },
  {
    infinitive: "kjøpe",
    present: "kjøper",
    past: "kjøpte",
    present_perfect: "har kjøpt",
    english: "purchase",
  },
  {
    infinitive: "kjøre",
    present: "kjører",
    past: "kjørte",
    present_perfect: "har kjørt",
    english: "drive",
  },
  {
    infinitive: "klage",
    present: "klager",
    past: "klaget, klaga, klagde",
    present_perfect: "har klaget, har klaga, har klagd",
    english: "complain",
  },
  {
    infinitive: "klare",
    present: "klarer",
    past: "klarte",
    present_perfect: "har klart",
    english: "manage",
  },
  {
    infinitive: "kle",
    present: "kler",
    past: "kledde",
    present_perfect: "har kledd",
    english: "dress, suit one",
  },
  {
    infinitive: "klippe",
    present: "klipper",
    past: "klippet, klippa",
    present_perfect: "har klippet, har klippa",
    english: "cut",
  },
  {
    infinitive: "knekke",
    present: "knekker",
    past: "knakk",
    present_perfect: "har knekt, har knekket",
    english: "crack, snap",
  },
  {
    infinitive: "koke",
    present: "koker",
    past: "kokte",
    present_perfect: "har kokt",
    english: "boil",
  },
  {
    infinitive: "komme",
    present: "kommer",
    past: "kom",
    present_perfect: "har kommet",
    english: "come",
  },
  {
    infinitive: "kose",
    present: "koser",
    past: "koste, kosa",
    present_perfect: "har kost, har kosa",
    english: "make cozy",
  },
  {
    infinitive: "koste",
    present: "koster",
    past: "kostet, kosta",
    present_perfect: "har kostet, har kosta",
    english: "cost, sweep",
  },
  {
    infinitive: "kreve",
    present: "krever",
    past: "krevde",
    present_perfect: "har krevd",
    english: "demand",
  },
  {
    infinitive: "kritisere",
    present: "kritiserer",
    past: "kritiserte",
    present_perfect: "har kritisert",
    english: "criticize",
  },
  {
    infinitive: "krype",
    present: "kryper",
    past: "krøp",
    present_perfect: "har krøpet",
    english: "creep",
  },
  {
    infinitive: "kunne",
    present: "kan",
    past: "kunne",
    present_perfect: "har kunnet",
    english: "be able to",
  },
  {
    infinitive: "kvede",
    present: "kveder",
    past: "kvad",
    present_perfect: "har kvedet",
    english: "chant, sing",
  },
  {
    infinitive: "la",
    present: "lar",
    past: "lot",
    present_perfect: "har latt",
    english: "allow, let",
  },
  {
    infinitive: "lage",
    present: "lager",
    past: "laget, lagde",
    present_perfect: "har laget, har lagd",
    english: "make, create",
  },
  {
    infinitive: "late",
    present: "later",
    past: "lot",
    present_perfect: "har latt",
    english: "pretend",
  },
  {
    infinitive: "le",
    present: "ler",
    past: "lo",
    present_perfect: "har ledd",
    english: "laugh",
  },
  {
    infinitive: "lede",
    present: "leder",
    past: "ledet",
    present_perfect: "har ledet",
    english: "lead",
  },
  {
    infinitive: "lege",
    present: "leger",
    past: "leget",
    present_perfect: "har leget",
    english: "heal, cure",
  },
  {
    infinitive: "legge",
    present: "legger",
    past: "la",
    present_perfect: "har lagt",
    english: "lay, place",
  },
  {
    infinitive: "leie",
    present: "leier",
    past: "leide",
    present_perfect: "har leid",
    english: "rent",
  },
  {
    infinitive: "leke",
    present: "leker",
    past: "lekte",
    present_perfect: "har lekt",
    english: "play",
  },
  {
    infinitive: "lekke",
    present: "lekker",
    past: "lakk",
    present_perfect: "har lekket",
    english: "leak",
  },
  {
    infinitive: "lese",
    present: "leser",
    past: "leste",
    present_perfect: "har lest",
    english: "read, study",
  },
  {
    infinitive: "leve",
    present: "lever",
    past: "levde",
    present_perfect: "har levd",
    english: "live, be alive",
  },
  {
    infinitive: "lide",
    present: "lider",
    past: "led",
    present_perfect: "har lidd",
    english: "suffer",
  },
  {
    infinitive: "ligge",
    present: "ligger",
    past: "lå",
    present_perfect: "har ligget",
    english: "lie",
  },
  {
    infinitive: "ligne",
    present: "ligner",
    past: "lignet, ligna",
    present_perfect: "har lignet, har ligna",
    english: "resemble, look like",
  },
  {
    infinitive: "likne",
    present: "likner",
    past: "liknet, likna",
    present_perfect: "har liknet, har likna",
    english: "resemble, look like",
  },
  {
    infinitive: "like",
    present: "liker",
    past: "likte",
    present_perfect: "har likt",
    english: "like",
  },
  {
    infinitive: "love",
    present: "lover",
    past: "lovet, lova",
    present_perfect: "har lovet, har lova",
    english: "promise, praise",
  },
  {
    infinitive: "lukke",
    present: "lukker",
    past: "lukket, lukka",
    present_perfect: "har lukket, har lukka",
    english: "shut",
  },
  {
    infinitive: "lukte",
    present: "lukter",
    past: "luktet, lukta",
    present_perfect: "har luktet, har lukta",
    english: "smell",
  },
  {
    infinitive: "lure",
    present: "lurer",
    past: "lurte",
    present_perfect: "har lurt",
    english: "wonder, dupe",
  },
  {
    infinitive: "lytte",
    present: "lytter",
    past: "lyttet, lytta",
    present_perfect: "har lyttet, har lytta",
    english: "listen",
  },
  {
    infinitive: "lyve",
    present: "lyver",
    past: "løy",
    present_perfect: "har løyet",
    english: "lie, fib",
  },
  {
    infinitive: "lære",
    present: "lærer",
    past: "lærte",
    present_perfect: "har lært",
    english: "learn, teach",
  },
  {
    infinitive: "løpe",
    present: "løper",
    past: "løp",
    present_perfect: "har løpt",
    english: "run",
  },
  {
    infinitive: "låne",
    present: "låner",
    past: "lånte",
    present_perfect: "har lånt",
    english: "lend, borrow",
  },
  {
    infinitive: "male",
    present: "maler",
    past: "malte",
    present_perfect: "har malt",
    english: "paint, purr",
  },
  {
    infinitive: "melde",
    present: "melder",
    past: "meldte",
    present_perfect: "har meldt",
    english: "announce, report",
  },
  {
    infinitive: "mene",
    present: "mener",
    past: "mente",
    present_perfect: "har ment",
    english: "think, be of the opinion",
  },
  {
    infinitive: "merke",
    present: "merker",
    past: "merket, merka",
    present_perfect: "har merket, har merka",
    english: "mark",
  },
  {
    infinitive: "misbruke",
    present: "misbruker",
    past: "misbrukte",
    present_perfect: "har misbrukt",
    english: "misuse, abuse",
  },
  {
    infinitive: "mislike",
    present: "misliker",
    past: "mislikte",
    present_perfect: "har mislikt",
    english: "dislike",
  },
  {
    infinitive: "motta",
    present: "mottar",
    past: "mottok",
    present_perfect: "har mottatt",
    english: "receive",
  },
  {
    infinitive: "møte",
    present: "møter",
    past: "møtte",
    present_perfect: "har møtt",
    english: "meet",
  },
  {
    infinitive: "måtte",
    present: "må",
    past: "måtte",
    present_perfect: "har måttet",
    english: "have to, be obliged to",
  },
  {
    infinitive: "nyte",
    present: "nyter",
    past: "nøt",
    present_perfect: "har nytt",
    english: "enjoy",
  },
  {
    infinitive: "pipe",
    present: "piper",
    past: "pep",
    present_perfect: "har pepet",
    english: "whistle, pipe",
  },
  {
    infinitive: "prøve",
    present: "prøver",
    past: "prøvde",
    present_perfect: "har prøvd",
    english: "try, attempt",
  },
  {
    infinitive: "reise",
    present: "reiser",
    past: "reiste",
    present_perfect: "har reist",
    english: "travel, raise",
  },
  {
    infinitive: "rekke",
    present: "rekker",
    past: "rakk",
    present_perfect: "har rukket",
    english: "reach, be enough",
  },
  {
    infinitive: "rekke",
    present: "rekker",
    past: "rakte",
    present_perfect: "har rakt",
    english: "stretch",
  },
  {
    infinitive: "ri",
    present: "rir",
    past: "red, rei",
    present_perfect: "har ridd",
    english: "ride (horse)",
  },
  {
    infinitive: "rive",
    present: "river",
    past: "rev, reiv",
    present_perfect: "har revet",
    english: "tear apart",
  },
  {
    infinitive: "ryke",
    present: "ryker",
    past: "røk",
    present_perfect: "har røket",
    english: "send out smoke, steam",
  },
  {
    infinitive: "røyke",
    present: "røyker",
    past: "røykte",
    present_perfect: "har røykt",
    english: "smoke (a cigarette)",
  },
  {
    infinitive: "se",
    present: "ser",
    past: "så",
    present_perfect: "har sett",
    english: "see",
  },
  {
    infinitive: "selge",
    present: "selger",
    past: "solgte",
    present_perfect: "har solgt",
    english: "sell",
  },
  {
    infinitive: "sende",
    present: "sender",
    past: "sendte",
    present_perfect: "har sendt",
    english: "send",
  },
  {
    infinitive: "sette",
    present: "setter",
    past: "satte",
    present_perfect: "har satt",
    english: "set, place",
  },
  {
    infinitive: "si",
    present: "sier",
    past: "sa",
    present_perfect: "har sagt",
    english: "say, tell",
  },
  {
    infinitive: "sige",
    present: "siger",
    past: "seig",
    present_perfect: "har seget",
    english: "sink",
  },
  {
    infinitive: "sitte",
    present: "sitter",
    past: "satt",
    present_perfect: "har sittet",
    english: "sit",
  },
  {
    infinitive: "skje",
    present: "skjer",
    past: "skjedde",
    present_perfect: "har skjedd",
    english: "happen",
  },
  {
    infinitive: "skjelve",
    present: "skjelver",
    past: "skalv",
    present_perfect: "har skjelvet",
    english: "sjake, tremble",
  },
  {
    infinitive: "skjære",
    present: "skjærer",
    past: "skar",
    present_perfect: "har skåret",
    english: "cut",
  },
  {
    infinitive: "skli",
    present: "sklir",
    past: "sklei, sklidde",
    present_perfect: "har sklidd",
    english: "slide",
  },
  {
    infinitive: "skrike",
    present: "skriker",
    past: "skrek, skreik",
    present_perfect: "har skreket",
    english: "scream",
  },
  {
    infinitive: "skrive",
    present: "skriver",
    past: "skrev, skreiv",
    present_perfect: "har skrevet",
    english: "write",
  },
  {
    infinitive: "skulle",
    present: "skal",
    past: "skulle",
    present_perfect: "har skullet",
    english: "should, shall",
  },
  {
    infinitive: "skvette",
    present: "skvetter",
    past: "skvatt",
    present_perfect: "har skvettet",
    english: "start suddenly, splash",
  },
  {
    infinitive: "skyte",
    present: "skyter",
    past: "skjøt",
    present_perfect: "har skutt",
    english: "shoot",
  },
  {
    infinitive: "skyve",
    present: "skyver",
    past: "skjøv",
    present_perfect: "har skjøvet",
    english: "shove",
  },
  {
    infinitive: "slippe",
    present: "slipper",
    past: "slapp",
    present_perfect: "har sloppet",
    english: "let go",
  },
  {
    infinitive: "slite",
    present: "sliter",
    past: "slet, sleit",
    present_perfect: "har slitt",
    english: "toil, wear out",
  },
  {
    infinitive: "slå",
    present: "slår",
    past: "slo",
    present_perfect: "har slått",
    english: "hit, strike",
  },
  {
    infinitive: "slåss",
    present: "slåss",
    past: "sloss",
    present_perfect: "har slåss",
    english: "fight",
  },
  {
    infinitive: "smøre",
    present: "smører",
    past: "smurte",
    present_perfect: "har smurt",
    english: "butter, smear",
  },
  {
    infinitive: "sove",
    present: "sover",
    past: "sov",
    present_perfect: "har sovet",
    english: "sleep",
  },
  {
    infinitive: "sprekke",
    present: "sprekker",
    past: "sprakk",
    present_perfect: "har sprukket",
    english: "burst, split",
  },
  {
    infinitive: "springe",
    present: "springer",
    past: "sprang",
    present_perfect: "har sprunget",
    english: "run",
  },
  {
    infinitive: "spørre",
    present: "spør",
    past: "spurte",
    present_perfect: "har spurt",
    english: "ask",
  },
  {
    infinitive: "stige",
    present: "stiger",
    past: "steg",
    present_perfect: "har steget",
    english: "climb",
  },
  {
    infinitive: "stikke",
    present: "stikker",
    past: "stakk",
    present_perfect: "har stukket",
    english: "stick, stab, leave (slang)",
  },
  {
    infinitive: "stjele",
    present: "stjeler",
    past: "stjal",
    present_perfect: "har stålet",
    english: "steal",
  },
  {
    infinitive: "stryke",
    present: "stryker",
    past: "strøk",
    present_perfect: "har strøket",
    english: "strike, iron, remove, fail",
  },
  {
    infinitive: "stå",
    present: "står",
    past: "stod",
    present_perfect: "har stått",
    english: "stand, stand up",
  },
  {
    infinitive: "svi",
    present: "svir",
    past: "svidde, svei",
    present_perfect: "har svidd",
    english: "burn, suffer",
  },
  {
    infinitive: "svike",
    present: "sviker",
    past: "svek, sveik",
    present_perfect: "har sveket",
    english: "betray, disappoint",
  },
  {
    infinitive: "synes",
    present: "synes, syns",
    past: "syntes",
    present_perfect: "har synes, har syns",
    english: "seem, think, be visible",
  },
  {
    infinitive: "synge",
    present: "synger",
    past: "sang",
    present_perfect: "har sunget",
    english: "sing",
  },
  {
    infinitive: "synke",
    present: "synker",
    past: "sank",
    present_perfect: "har sunket",
    english: "sink",
  },
  {
    infinitive: "søke",
    present: "søker",
    past: "søkte",
    present_perfect: "har søkt",
    english: "seek",
  },
  {
    infinitive: "ta",
    present: "tar",
    past: "tok",
    present_perfect: "har tatt",
    english: "take",
  },
  {
    infinitive: "telle",
    present: "teller",
    past: "talte",
    present_perfect: "har talt",
    english: "count",
  },
  {
    infinitive: "tenke",
    present: "tenker",
    past: "tenkte",
    present_perfect: "har tenkt",
    english: "think, intend",
  },
  {
    infinitive: "tigge",
    present: "tigger",
    past: "tagg",
    present_perfect: "har tigget",
    english: "beg, implore",
  },
  {
    infinitive: "tørre",
    present: "tør",
    past: "turte",
    present_perfect: "har turt",
    english: "dare",
  },
  {
    infinitive: "treffe",
    present: "treffer",
    past: "traff",
    present_perfect: "har truffet",
    english: "meet, hit",
  },
  {
    infinitive: "trekke",
    present: "trekker",
    past: "trakk",
    present_perfect: "har trukket",
    english: "drag, pull",
  },
  {
    infinitive: "trives",
    present: "trives",
    past: "trivdes",
    present_perfect: "har trives",
    english: "enjoy, thrive",
  },
  {
    infinitive: "tro",
    present: "tror",
    past: "trodde",
    present_perfect: "har trodd",
    english: "believe",
  },
  {
    infinitive: "tvile",
    present: "tviler",
    past: "tvilte",
    present_perfect: "har tvilt",
    english: "doubt",
  },
  {
    infinitive: "tvinge",
    present: "tvinger",
    past: "tvang",
    present_perfect: "har tvunget",
    english: "force",
  },
  {
    infinitive: "velge",
    present: "velger",
    past: "valgte",
    present_perfect: "har valgt",
    english: "choose, elect",
  },
  {
    infinitive: "vente",
    present: "venter",
    past: "ventet",
    present_perfect: "har ventet",
    english: "wait, expect",
  },
  {
    infinitive: "ville",
    present: "vil",
    past: "ville",
    present_perfect: "har villet",
    english: "want to, will",
  },
  {
    infinitive: "vinne",
    present: "vinner",
    past: "vant",
    present_perfect: "har vunnet",
    english: "win, gain",
  },
  {
    infinitive: "vise",
    present: "viser",
    past: "viste",
    present_perfect: "har vist",
    english: "show",
  },
  {
    infinitive: "vite",
    present: "vet",
    past: "visste",
    present_perfect: "har visst",
    english: "know (fact)",
  },
  {
    infinitive: "være",
    present: "er",
    past: "var",
    present_perfect: "har vært",
    english: "be, exist",
  },
  {
    infinitive: "ønske",
    present: "ønsker",
    past: "ønsket, ønska",
    present_perfect: "har ønsket, har ønska",
    english: "wish, desire",
  },
  {
    infinitive: "åpne",
    present: "åpner",
    past: "åpnet, åpna",
    present_perfect: "har åpnet, har åpna",
    english: "open",
  },
];

export const data_json = {
  angre: {
    infinitive: "angre",
    present: "angrer",
    past: "angret, angra",
    present_perfect: "har angret, har angra",
    english: "regret",
  },
  arbeide: {
    infinitive: "arbeide",
    present: "arbeider",
    past: "arbeidet",
    present_perfect: "har arbeidet",
    english: "work",
  },
  arrangere: {
    infinitive: "arrangere",
    present: "arrangerer",
    past: "arrangerte",
    present_perfect: "har arrangert",
    english: "arrange",
  },
  arve: {
    infinitive: "arve",
    present: "arver",
    past: "arvet, arva",
    present_perfect: "har arvet, har arva",
    english: "inherit",
  },
  be: {
    infinitive: "be",
    present: "ber",
    past: "ba",
    present_perfect: "har bedt",
    english: "ask, request",
  },
  begrave: {
    infinitive: "begrave",
    present: "begraver",
    past: "begravde",
    present_perfect: "har begravd",
    english: "bury",
  },
  begynne: {
    infinitive: "begynne",
    present: "begynner",
    past: "begynte",
    present_perfect: "har begynt",
    english: "begin",
  },
  behandle: {
    infinitive: "behandle",
    present: "behandler",
    past: "behandlet, behandla",
    present_perfect: "har behandlet, har behandla",
    english: "handle, manage",
  },
  beholde: {
    infinitive: "beholde",
    present: "beholder",
    past: "beholdt",
    present_perfect: "har beholdt",
    english: "retain, keep",
  },
  bestemme: {
    infinitive: "bestemme",
    present: "bestemmer",
    past: "bestemte",
    present_perfect: "har bestemt",
    english: "decide",
  },
  bestille: {
    infinitive: "bestille",
    present: "bestiller",
    past: "bestilte",
    present_perfect: "har bestilt",
    english: "order",
  },
  besøke: {
    infinitive: "besøke",
    present: "besøker",
    past: "besøkte",
    present_perfect: "har besøkt",
    english: "visit",
  },
  betale: {
    infinitive: "betale",
    present: "betaler",
    past: "betalte",
    present_perfect: "har betalt",
    english: "pay",
  },
  betrakte: {
    infinitive: "betrakte",
    present: "betrakter",
    past: "betraktet, betrakta",
    present_perfect: "har betraktet, har betrakta",
    english: "view, regard",
  },
  bety: {
    infinitive: "bety",
    present: "betyr",
    past: "betydde",
    present_perfect: "har betydd",
    english: "mean, signify",
  },
  bevare: {
    infinitive: "bevare",
    present: "bevarer",
    past: "bevarte",
    present_perfect: "har bevart",
    english: "save, maintain",
  },
  bidra: {
    infinitive: "bidra",
    present: "bidrar",
    past: "bidro",
    present_perfect: "har bidratt",
    english: "contribute",
  },
  binde: {
    infinitive: "binde",
    present: "binder",
    past: "bandt",
    present_perfect: "har bundet",
    english: "bind",
  },
  bite: {
    infinitive: "bite",
    present: "biter",
    past: "bet, beit",
    present_perfect: "har bitt",
    english: "bite",
  },
  blande: {
    infinitive: "blande",
    present: "blander",
    past: "blandet, blanda",
    present_perfect: "har blandet, har blanda",
    english: "blend, mix",
  },
  bli: {
    infinitive: "bli",
    present: "blir",
    past: "ble",
    present_perfect: "har blitt",
    english: "remain, become",
  },
  bo: {
    infinitive: "bo",
    present: "bor",
    past: "bodde",
    present_perfect: "har bodd",
    english: "to live (location)",
  },
  bre: {
    infinitive: "bre",
    present: "brer",
    past: "bredte",
    present_perfect: "har bredt",
    english: "spread",
  },
  brekke: {
    infinitive: "brekke",
    present: "brekker",
    past: "brakk",
    present_perfect: "har brukket",
    english: "break",
  },
  "brenne (opp)": {
    infinitive: "brenne (opp)",
    present: "brenner (opp)",
    past: "brant (opp)",
    present_perfect: "har brant (opp)",
    english: "burn up",
  },
  brenne: {
    infinitive: "brenne",
    present: "brenner",
    past: "brente",
    present_perfect: "har brent",
    english: "set fire to",
  },
  bringe: {
    infinitive: "bringe",
    present: "bringer",
    past: "brakte",
    present_perfect: "har brakt",
    english: "bring",
  },
  bruke: {
    infinitive: "bruke",
    present: "bruker",
    past: "brukte",
    present_perfect: "har brukt",
    english: "use",
  },
  bryte: {
    infinitive: "bryte",
    present: "bryter",
    past: "brøt",
    present_perfect: "har brutt",
    english: "break",
  },
  burde: {
    infinitive: "burde",
    present: "bør",
    past: "burde",
    present_perfect: "burdet",
    english: "should",
  },
  by: {
    infinitive: "by",
    present: "byr",
    past: "bydde, bød",
    present_perfect: "har bydd, har budt",
    english: "bid, command",
  },
  bygge: {
    infinitive: "bygge",
    present: "bygger",
    past: "bygde",
    present_perfect: "har bygd",
    english: "build",
  },
  bære: {
    infinitive: "bære",
    present: "bærer",
    past: "bar",
    present_perfect: "har båret",
    english: "bear, carry",
  },
  bøye: {
    infinitive: "bøye",
    present: "bøyer",
    past: "bøyde",
    present_perfect: "har bøyd",
    english: "bend, conjugate",
  },
  danne: {
    infinitive: "danne",
    present: "danner",
    past: "dannet, danna",
    present_perfect: "har dannet, har danna",
    english: "form, create",
  },
  danse: {
    infinitive: "danse",
    present: "danser",
    past: "danset, dansa",
    present_perfect: "har danset, har dansa",
    english: "dance",
  },
  dekke: {
    infinitive: "dekke",
    present: "dekker",
    past: "dekket, dekka",
    present_perfect: "har dekket, har dekka",
    english: "cover, set",
  },
  dele: {
    infinitive: "dele",
    present: "deler",
    past: "delte",
    present_perfect: "har delt",
    english: "divide, share",
  },
  dra: {
    infinitive: "dra",
    present: "drar",
    past: "dro",
    present_perfect: "har dradd, har dratt",
    english: "drag, travel",
  },
  drepe: {
    infinitive: "drepe",
    present: "dreper",
    past: "drepte",
    present_perfect: "har drept",
    english: "kill",
  },
  drikke: {
    infinitive: "drikke",
    present: "drikker",
    past: "drakk",
    present_perfect: "har drukket",
    english: "drink",
  },
  drive: {
    infinitive: "drive",
    present: "driver",
    past: "drev, dreiv",
    present_perfect: "har drevet",
    english: "operate, run",
  },
  dyrke: {
    infinitive: "dyrke",
    present: "dyrker",
    past: "dyrket, dyrka",
    present_perfect: "har dyrket, har dyrka",
    english: "cultivate, raise",
  },
  dø: {
    infinitive: "dø",
    present: "dør",
    past: "døde",
    present_perfect: "har dødd",
    english: "die",
  },
  døpe: {
    infinitive: "døpe",
    present: "døper",
    past: "døpte",
    present_perfect: "har døpt",
    english: "baptize",
  },
  eie: {
    infinitive: "eie",
    present: "eier",
    past: "eide",
    present_perfect: "har eid",
    english: "own",
  },
  elske: {
    infinitive: "elske",
    present: "elsker",
    past: "elsket",
    present_perfect: "har elsket",
    english: "love",
  },
  ete: {
    infinitive: "ete",
    present: "eter",
    past: "åt",
    present_perfect: "har ett",
    english: "eat (slang)",
  },
  falle: {
    infinitive: "falle",
    present: "faller",
    past: "falt",
    present_perfect: "har falt",
    english: "fall",
  },
  fare: {
    infinitive: "fare",
    present: "farer",
    past: "for",
    present_perfect: "har faret",
    english: "fare, travel",
  },
  finne: {
    infinitive: "finne",
    present: "finner",
    past: "fant",
    present_perfect: "har funnet",
    english: "find",
  },
  finnes: {
    infinitive: "finnes",
    present: "finnes, fins",
    past: "fantes",
    present_perfect: "har fantes",
    english: "be found, exist",
  },
  fly: {
    infinitive: "fly",
    present: "flyr",
    past: "fløy",
    present_perfect: "har fløyet, har flydd",
    english: "fly",
  },
  flyte: {
    infinitive: "flyte",
    present: "flyter",
    past: "fløt",
    present_perfect: "har flytt",
    english: "flow",
  },
  flytte: {
    infinitive: "flytte",
    present: "flytter",
    past: "flyttet, flytta",
    present_perfect: "har flyttet, har flytta",
    english: "move",
  },
  forberede: {
    infinitive: "forberede",
    present: "forbereder",
    past: "forberedte",
    present_perfect: "har forberedt",
    english: "prepare",
  },
  forby: {
    infinitive: "forby",
    present: "forbyr",
    past: "forbød",
    present_perfect: "har forbudt",
    english: "forbid, prohibit",
  },
  forene: {
    infinitive: "forene",
    present: "forener",
    past: "forente",
    present_perfect: "har forent",
    english: "unite",
  },
  foretrekke: {
    infinitive: "foretrekke",
    present: "foretrekker",
    past: "foretrakk",
    present_perfect: "har foretrukket",
    english: "prefer",
  },
  forklare: {
    infinitive: "forklare",
    present: "forklarer",
    past: "forklarte",
    present_perfect: "har forklart",
    english: "explain",
  },
  forlate: {
    infinitive: "forlate",
    present: "forlater",
    past: "forlot",
    present_perfect: "har forlatt",
    english: "forsake, leave",
  },
  "forlove (seg)": {
    infinitive: "forlove (seg)",
    present: "forlover (seg)",
    past: "forlovet (seg), forlova (seg)",
    present_perfect: "har forlovet (seg), har forlova (seg)",
    english: "become engaged",
  },
  fornemme: {
    infinitive: "fornemme",
    present: "fornemmer",
    past: "fornemmet",
    present_perfect: "har fornemmet",
    english: "perceive, notice",
  },
  forstå: {
    infinitive: "forstå",
    present: "forstår",
    past: "forstod",
    present_perfect: "har forstått",
    english: "understand",
  },
  forsvinne: {
    infinitive: "forsvinne",
    present: "forsvinner",
    past: "forsvant",
    present_perfect: "har forsvunnet",
    english: "disappear",
  },
  forsyne: {
    infinitive: "forsyne",
    present: "forsyner",
    past: "forsynte",
    present_perfect: "har forsynt",
    english: "supply, provide",
  },
  fortelle: {
    infinitive: "fortelle",
    present: "forteller",
    past: "fortalte",
    present_perfect: "har fortalt",
    english: "tell, explain",
  },
  fryse: {
    infinitive: "fryse",
    present: "fryser",
    past: "frøs",
    present_perfect: "har frosset",
    english: "freeze, feel cold",
  },
  følge: {
    infinitive: "følge",
    present: "følger",
    past: "fulgte",
    present_perfect: "har fulgt",
    english: "follow",
  },
  få: {
    infinitive: "få",
    present: "får",
    past: "fikk",
    present_perfect: "har fått",
    english: "get, receive",
  },
  gi: {
    infinitive: "gi",
    present: "gir",
    past: "gav",
    present_perfect: "har gitt",
    english: "give",
  },
  gidde: {
    infinitive: "gidde",
    present: "gidder",
    past: "gadd",
    present_perfect: "har giddet",
    english: "manage to do something",
  },
  gjelde: {
    infinitive: "gjelde",
    present: "gjelder",
    past: "gjaldt",
    present_perfect: "har gjeldt",
    english: "be in force, apply",
  },
  gjøre: {
    infinitive: "gjøre",
    present: "gjør",
    past: "gjorde",
    present_perfect: "har gjort",
    english: "do",
  },
  glede: {
    infinitive: "glede",
    present: "gleder",
    past: "gledet",
    present_perfect: "har gledet",
    english: "please, make happy",
  },
  glemme: {
    infinitive: "glemme",
    present: "glemmer",
    past: "glemte",
    present_perfect: "har glemt",
    english: "forget",
  },
  gli: {
    infinitive: "gli",
    present: "glir",
    past: "glei",
    present_perfect: "har glidd",
    english: "glide",
  },
  glimre: {
    infinitive: "glimre",
    present: "glimrer",
    past: "glimret",
    present_perfect: "har glimret",
    english: "glisten",
  },
  gnage: {
    infinitive: "gnage",
    present: "gnager",
    past: "gnog, gnagde",
    present_perfect: "har gnagd",
    english: "gnaw",
  },
  gni: {
    infinitive: "gni",
    present: "gnir",
    past: "gned, gnidde, gnei",
    present_perfect: "har gnidd",
    english: "rub",
  },
  grave: {
    infinitive: "grave",
    present: "graver",
    past: "gravde",
    present_perfect: "har gravd",
    english: "dig",
  },
  "gre (seg)": {
    infinitive: "gre (seg)",
    present: "grer (seg)",
    past: "gredde (seg)",
    present_perfect: "har gredd (seg)",
    english: "comb one's hair",
  },
  greie: {
    infinitive: "greie",
    present: "greier",
    past: "greide",
    present_perfect: "har greid",
    english: "manage, deal with",
  },
  gripe: {
    infinitive: "gripe",
    present: "griper",
    past: "grep, greip",
    present_perfect: "har grepet",
    english: "grasp, seize",
  },
  gråte: {
    infinitive: "gråte",
    present: "gråter",
    past: "gråt",
    present_perfect: "har grått",
    english: "cry, weep",
  },
  gå: {
    infinitive: "gå",
    present: "går",
    past: "gikk",
    present_perfect: "har gått",
    english: "go, walk",
  },
  ha: {
    infinitive: "ha",
    present: "har",
    past: "hadde",
    present_perfect: "har hatt",
    english: "have",
  },
  handle: {
    infinitive: "handle",
    present: "handler",
    past: "handlet, handla",
    present_perfect: "har handlet, har handla",
    english: "act, shop, deal with",
  },
  hende: {
    infinitive: "hende",
    present: "hender",
    past: "hendte",
    present_perfect: "har hendt",
    english: "happen",
  },
  henge: {
    infinitive: "henge",
    present: "henger",
    past: "hang",
    present_perfect: "har hengt",
    english: "hang, droop",
  },
  hente: {
    infinitive: "hente",
    present: "henter",
    past: "hentet, henta",
    present_perfect: "har hentet, har henta",
    english: "fetch, bring",
  },
  hete: {
    infinitive: "hete",
    present: "heter",
    past: "het",
    present_perfect: "har hett",
    english: "be named",
  },
  heve: {
    infinitive: "heve",
    present: "hever",
    past: "hevet, hevde",
    present_perfect: "har hevet, har hevd",
    english: "raise",
  },
  hilse: {
    infinitive: "hilse",
    present: "hilser",
    past: "hilste",
    present_perfect: "har hilst",
    english: "greet",
  },
  hjelpe: {
    infinitive: "hjelpe",
    present: "hjelper",
    past: "hjalp",
    present_perfect: "har hjulpet",
    english: "help",
  },
  holde: {
    infinitive: "holde",
    present: "holder",
    past: "holdt",
    present_perfect: "har holdt",
    english: "keep, hold",
  },
  hoppe: {
    infinitive: "hoppe",
    present: "hopper",
    past: "hoppet, hoppa",
    present_perfect: "har hoppet, har hoppa",
    english: "hop",
  },
  huske: {
    infinitive: "huske",
    present: "husker",
    past: "husket",
    present_perfect: "har husket",
    english: "remember",
  },
  hvile: {
    infinitive: "hvile",
    present: "hviler",
    past: "hvilte",
    present_perfect: "har hvilt",
    english: "rest",
  },
  høre: {
    infinitive: "høre",
    present: "hører",
    past: "hørte",
    present_perfect: "har hørt",
    english: "hear",
  },
  håndhilse: {
    infinitive: "håndhilse",
    present: "håndhilser",
    past: "håndhilste",
    present_perfect: "har håndhilst",
    english: "shake hands",
  },
  inkludere: {
    infinitive: "inkludere",
    present: "inkluderer",
    past: "inkluderte",
    present_perfect: "har inkludert",
    english: "include",
  },
  innføre: {
    infinitive: "innføre",
    present: "innfører",
    past: "innførte",
    present_perfect: "har innført",
    english: "introduce",
  },
  interessere: {
    infinitive: "interessere",
    present: "interesserer",
    past: "interesserte",
    present_perfect: "har interessert",
    english: "interest",
  },
  invitere: {
    infinitive: "invitere",
    present: "inviterer",
    past: "inviterte",
    present_perfect: "har invitert",
    english: "invite",
  },
  jobbe: {
    infinitive: "jobbe",
    present: "jobber",
    past: "jobbet, jobba",
    present_perfect: "har jobbet, har jobba",
    english: "work",
  },
  kjempe: {
    infinitive: "kjempe",
    present: "kjemper",
    past: "kjempet, kjempa",
    present_perfect: "har kjempet, har kjempa",
    english: "fight",
  },
  kjenne: {
    infinitive: "kjenne",
    present: "kjenner",
    past: "kjente",
    present_perfect: "har kjent",
    english: "know (person, place)",
  },
  kjøpe: {
    infinitive: "kjøpe",
    present: "kjøper",
    past: "kjøpte",
    present_perfect: "har kjøpt",
    english: "purchase",
  },
  kjøre: {
    infinitive: "kjøre",
    present: "kjører",
    past: "kjørte",
    present_perfect: "har kjørt",
    english: "drive",
  },
  klage: {
    infinitive: "klage",
    present: "klager",
    past: "klaget, klaga, klagde",
    present_perfect: "har klaget, har klaga, har klagd",
    english: "complain",
  },
  klare: {
    infinitive: "klare",
    present: "klarer",
    past: "klarte",
    present_perfect: "har klart",
    english: "manage",
  },
  kle: {
    infinitive: "kle",
    present: "kler",
    past: "kledde",
    present_perfect: "har kledd",
    english: "dress, suit one",
  },
  klippe: {
    infinitive: "klippe",
    present: "klipper",
    past: "klippet, klippa",
    present_perfect: "har klippet, har klippa",
    english: "cut",
  },
  knekke: {
    infinitive: "knekke",
    present: "knekker",
    past: "knakk",
    present_perfect: "har knekt, har knekket",
    english: "crack, snap",
  },
  koke: {
    infinitive: "koke",
    present: "koker",
    past: "kokte",
    present_perfect: "har kokt",
    english: "boil",
  },
  komme: {
    infinitive: "komme",
    present: "kommer",
    past: "kom",
    present_perfect: "har kommet",
    english: "come",
  },
  kose: {
    infinitive: "kose",
    present: "koser",
    past: "koste, kosa",
    present_perfect: "har kost, har kosa",
    english: "make cozy",
  },
  koste: {
    infinitive: "koste",
    present: "koster",
    past: "kostet, kosta",
    present_perfect: "har kostet, har kosta",
    english: "cost, sweep",
  },
  kreve: {
    infinitive: "kreve",
    present: "krever",
    past: "krevde",
    present_perfect: "har krevd",
    english: "demand",
  },
  kritisere: {
    infinitive: "kritisere",
    present: "kritiserer",
    past: "kritiserte",
    present_perfect: "har kritisert",
    english: "criticize",
  },
  krype: {
    infinitive: "krype",
    present: "kryper",
    past: "krøp",
    present_perfect: "har krøpet",
    english: "creep",
  },
  kunne: {
    infinitive: "kunne",
    present: "kan",
    past: "kunne",
    present_perfect: "har kunnet",
    english: "be able to",
  },
  kvede: {
    infinitive: "kvede",
    present: "kveder",
    past: "kvad",
    present_perfect: "har kvedet",
    english: "chant, sing",
  },
  la: {
    infinitive: "la",
    present: "lar",
    past: "lot",
    present_perfect: "har latt",
    english: "allow, let",
  },
  lage: {
    infinitive: "lage",
    present: "lager",
    past: "laget, lagde",
    present_perfect: "har laget, har lagd",
    english: "make, create",
  },
  late: {
    infinitive: "late",
    present: "later",
    past: "lot",
    present_perfect: "har latt",
    english: "pretend",
  },
  le: {
    infinitive: "le",
    present: "ler",
    past: "lo",
    present_perfect: "har ledd",
    english: "laugh",
  },
  lede: {
    infinitive: "lede",
    present: "leder",
    past: "ledet",
    present_perfect: "har ledet",
    english: "lead",
  },
  lege: {
    infinitive: "lege",
    present: "leger",
    past: "leget",
    present_perfect: "har leget",
    english: "heal, cure",
  },
  legge: {
    infinitive: "legge",
    present: "legger",
    past: "la",
    present_perfect: "har lagt",
    english: "lay, place",
  },
  leie: {
    infinitive: "leie",
    present: "leier",
    past: "leide",
    present_perfect: "har leid",
    english: "rent",
  },
  leke: {
    infinitive: "leke",
    present: "leker",
    past: "lekte",
    present_perfect: "har lekt",
    english: "play",
  },
  lekke: {
    infinitive: "lekke",
    present: "lekker",
    past: "lakk",
    present_perfect: "har lekket",
    english: "leak",
  },
  lese: {
    infinitive: "lese",
    present: "leser",
    past: "leste",
    present_perfect: "har lest",
    english: "read, study",
  },
  leve: {
    infinitive: "leve",
    present: "lever",
    past: "levde",
    present_perfect: "har levd",
    english: "live, be alive",
  },
  lide: {
    infinitive: "lide",
    present: "lider",
    past: "led",
    present_perfect: "har lidd",
    english: "suffer",
  },
  ligge: {
    infinitive: "ligge",
    present: "ligger",
    past: "lå",
    present_perfect: "har ligget",
    english: "lie",
  },
  ligne: {
    infinitive: "ligne",
    present: "ligner",
    past: "lignet, ligna",
    present_perfect: "har lignet, har ligna",
    english: "resemble, look like",
  },
  likne: {
    infinitive: "likne",
    present: "likner",
    past: "liknet, likna",
    present_perfect: "har liknet, har likna",
    english: "resemble, look like",
  },
  like: {
    infinitive: "like",
    present: "liker",
    past: "likte",
    present_perfect: "har likt",
    english: "like",
  },
  love: {
    infinitive: "love",
    present: "lover",
    past: "lovet, lova",
    present_perfect: "har lovet, har lova",
    english: "promise, praise",
  },
  lukke: {
    infinitive: "lukke",
    present: "lukker",
    past: "lukket, lukka",
    present_perfect: "har lukket, har lukka",
    english: "shut",
  },
  lukte: {
    infinitive: "lukte",
    present: "lukter",
    past: "luktet, lukta",
    present_perfect: "har luktet, har lukta",
    english: "smell",
  },
  lure: {
    infinitive: "lure",
    present: "lurer",
    past: "lurte",
    present_perfect: "har lurt",
    english: "wonder, dupe",
  },
  lytte: {
    infinitive: "lytte",
    present: "lytter",
    past: "lyttet, lytta",
    present_perfect: "har lyttet, har lytta",
    english: "listen",
  },
  lyve: {
    infinitive: "lyve",
    present: "lyver",
    past: "løy",
    present_perfect: "har løyet",
    english: "lie, fib",
  },
  lære: {
    infinitive: "lære",
    present: "lærer",
    past: "lærte",
    present_perfect: "har lært",
    english: "learn, teach",
  },
  løpe: {
    infinitive: "løpe",
    present: "løper",
    past: "løp",
    present_perfect: "har løpt",
    english: "run",
  },
  låne: {
    infinitive: "låne",
    present: "låner",
    past: "lånte",
    present_perfect: "har lånt",
    english: "lend, borrow",
  },
  male: {
    infinitive: "male",
    present: "maler",
    past: "malte",
    present_perfect: "har malt",
    english: "paint, purr",
  },
  melde: {
    infinitive: "melde",
    present: "melder",
    past: "meldte",
    present_perfect: "har meldt",
    english: "announce, report",
  },
  mene: {
    infinitive: "mene",
    present: "mener",
    past: "mente",
    present_perfect: "har ment",
    english: "think, be of the opinion",
  },
  merke: {
    infinitive: "merke",
    present: "merker",
    past: "merket, merka",
    present_perfect: "har merket, har merka",
    english: "mark",
  },
  misbruke: {
    infinitive: "misbruke",
    present: "misbruker",
    past: "misbrukte",
    present_perfect: "har misbrukt",
    english: "misuse, abuse",
  },
  mislike: {
    infinitive: "mislike",
    present: "misliker",
    past: "mislikte",
    present_perfect: "har mislikt",
    english: "dislike",
  },
  motta: {
    infinitive: "motta",
    present: "mottar",
    past: "mottok",
    present_perfect: "har mottatt",
    english: "receive",
  },
  møte: {
    infinitive: "møte",
    present: "møter",
    past: "møtte",
    present_perfect: "har møtt",
    english: "meet",
  },
  måtte: {
    infinitive: "måtte",
    present: "må",
    past: "måtte",
    present_perfect: "har måttet",
    english: "have to, be obliged to",
  },
  nyte: {
    infinitive: "nyte",
    present: "nyter",
    past: "nøt",
    present_perfect: "har nytt",
    english: "enjoy",
  },
  pipe: {
    infinitive: "pipe",
    present: "piper",
    past: "pep",
    present_perfect: "har pepet",
    english: "whistle, pipe",
  },
  prøve: {
    infinitive: "prøve",
    present: "prøver",
    past: "prøvde",
    present_perfect: "har prøvd",
    english: "try, attempt",
  },
  reise: {
    infinitive: "reise",
    present: "reiser",
    past: "reiste",
    present_perfect: "har reist",
    english: "travel, raise",
  },
  rekke: {
    infinitive: "rekke",
    present: "rekker",
    past: "rakk",
    present_perfect: "har rukket",
    english: "reach, be enough",
  },
  ri: {
    infinitive: "ri",
    present: "rir",
    past: "red, rei",
    present_perfect: "har ridd",
    english: "ride (horse)",
  },
  rive: {
    infinitive: "rive",
    present: "river",
    past: "rev, reiv",
    present_perfect: "har revet",
    english: "tear apart",
  },
  ryke: {
    infinitive: "ryke",
    present: "ryker",
    past: "røk",
    present_perfect: "har røket",
    english: "send out smoke, steam",
  },
  røyke: {
    infinitive: "røyke",
    present: "røyker",
    past: "røykte",
    present_perfect: "har røykt",
    english: "smoke (a cigarette)",
  },
  se: {
    infinitive: "se",
    present: "ser",
    past: "så",
    present_perfect: "har sett",
    english: "see",
  },
  selge: {
    infinitive: "selge",
    present: "selger",
    past: "solgte",
    present_perfect: "har solgt",
    english: "sell",
  },
  sende: {
    infinitive: "sende",
    present: "sender",
    past: "sendte",
    present_perfect: "har sendt",
    english: "send",
  },
  sette: {
    infinitive: "sette",
    present: "setter",
    past: "satte",
    present_perfect: "har satt",
    english: "set, place",
  },
  si: {
    infinitive: "si",
    present: "sier",
    past: "sa",
    present_perfect: "har sagt",
    english: "say, tell",
  },
  sige: {
    infinitive: "sige",
    present: "siger",
    past: "seig",
    present_perfect: "har seget",
    english: "sink",
  },
  sitte: {
    infinitive: "sitte",
    present: "sitter",
    past: "satt",
    present_perfect: "har sittet",
    english: "sit",
  },
  skje: {
    infinitive: "skje",
    present: "skjer",
    past: "skjedde",
    present_perfect: "har skjedd",
    english: "happen",
  },
  skjelve: {
    infinitive: "skjelve",
    present: "skjelver",
    past: "skalv",
    present_perfect: "har skjelvet",
    english: "sjake, tremble",
  },
  skjære: {
    infinitive: "skjære",
    present: "skjærer",
    past: "skar",
    present_perfect: "har skåret",
    english: "cut",
  },
  skli: {
    infinitive: "skli",
    present: "sklir",
    past: "sklei, sklidde",
    present_perfect: "har sklidd",
    english: "slide",
  },
  skrike: {
    infinitive: "skrike",
    present: "skriker",
    past: "skrek, skreik",
    present_perfect: "har skreket",
    english: "scream",
  },
  skrive: {
    infinitive: "skrive",
    present: "skriver",
    past: "skrev, skreiv",
    present_perfect: "har skrevet",
    english: "write",
  },
  skulle: {
    infinitive: "skulle",
    present: "skal",
    past: "skulle",
    present_perfect: "har skullet",
    english: "should, shall",
  },
  skvette: {
    infinitive: "skvette",
    present: "skvetter",
    past: "skvatt",
    present_perfect: "har skvettet",
    english: "start suddenly, splash",
  },
  skyte: {
    infinitive: "skyte",
    present: "skyter",
    past: "skjøt",
    present_perfect: "har skutt",
    english: "shoot",
  },
  skyve: {
    infinitive: "skyve",
    present: "skyver",
    past: "skjøv",
    present_perfect: "har skjøvet",
    english: "shove",
  },
  slippe: {
    infinitive: "slippe",
    present: "slipper",
    past: "slapp",
    present_perfect: "har sloppet",
    english: "let go",
  },
  slite: {
    infinitive: "slite",
    present: "sliter",
    past: "slet, sleit",
    present_perfect: "har slitt",
    english: "toil, wear out",
  },
  slå: {
    infinitive: "slå",
    present: "slår",
    past: "slo",
    present_perfect: "har slått",
    english: "hit, strike",
  },
  slåss: {
    infinitive: "slåss",
    present: "slåss",
    past: "sloss",
    present_perfect: "har slåss",
    english: "fight",
  },
  smøre: {
    infinitive: "smøre",
    present: "smører",
    past: "smurte",
    present_perfect: "har smurt",
    english: "butter, smear",
  },
  sove: {
    infinitive: "sove",
    present: "sover",
    past: "sov",
    present_perfect: "har sovet",
    english: "sleep",
  },
  sprekke: {
    infinitive: "sprekke",
    present: "sprekker",
    past: "sprakk",
    present_perfect: "har sprukket",
    english: "burst, split",
  },
  springe: {
    infinitive: "springe",
    present: "springer",
    past: "sprang",
    present_perfect: "har sprunget",
    english: "run",
  },
  spørre: {
    infinitive: "spørre",
    present: "spør",
    past: "spurte",
    present_perfect: "har spurt",
    english: "ask",
  },
  stige: {
    infinitive: "stige",
    present: "stiger",
    past: "steg",
    present_perfect: "har steget",
    english: "climb",
  },
  stikke: {
    infinitive: "stikke",
    present: "stikker",
    past: "stakk",
    present_perfect: "har stukket",
    english: "stick, stab, leave (slang)",
  },
  stjele: {
    infinitive: "stjele",
    present: "stjeler",
    past: "stjal",
    present_perfect: "har stålet",
    english: "steal",
  },
  stryke: {
    infinitive: "stryke",
    present: "stryker",
    past: "strøk",
    present_perfect: "har strøket",
    english: "strike, iron, remove, fail",
  },
  stå: {
    infinitive: "stå",
    present: "står",
    past: "stod",
    present_perfect: "har stått",
    english: "stand, stand up",
  },
  svi: {
    infinitive: "svi",
    present: "svir",
    past: "svidde, svei",
    present_perfect: "har svidd",
    english: "burn, suffer",
  },
  svike: {
    infinitive: "svike",
    present: "sviker",
    past: "svek, sveik",
    present_perfect: "har sveket",
    english: "betray, disappoint",
  },
  synes: {
    infinitive: "synes",
    present: "synes, syns",
    past: "syntes",
    present_perfect: "har synes, har syns",
    english: "seem, think, be visible",
  },
  synge: {
    infinitive: "synge",
    present: "synger",
    past: "sang",
    present_perfect: "har sunget",
    english: "sing",
  },
  synke: {
    infinitive: "synke",
    present: "synker",
    past: "sank",
    present_perfect: "har sunket",
    english: "sink",
  },
  søke: {
    infinitive: "søke",
    present: "søker",
    past: "søkte",
    present_perfect: "har søkt",
    english: "seek",
  },
  ta: {
    infinitive: "ta",
    present: "tar",
    past: "tok",
    present_perfect: "har tatt",
    english: "take",
  },
  telle: {
    infinitive: "telle",
    present: "teller",
    past: "talte",
    present_perfect: "har talt",
    english: "count",
  },
  tenke: {
    infinitive: "tenke",
    present: "tenker",
    past: "tenkte",
    present_perfect: "har tenkt",
    english: "think, intend",
  },
  tigge: {
    infinitive: "tigge",
    present: "tigger",
    past: "tagg",
    present_perfect: "har tigget",
    english: "beg, implore",
  },
  tørre: {
    infinitive: "tørre",
    present: "tør",
    past: "turte",
    present_perfect: "har turt",
    english: "dare",
  },
  treffe: {
    infinitive: "treffe",
    present: "treffer",
    past: "traff",
    present_perfect: "har truffet",
    english: "meet, hit",
  },
  trekke: {
    infinitive: "trekke",
    present: "trekker",
    past: "trakk",
    present_perfect: "har trukket",
    english: "drag, pull",
  },
  trives: {
    infinitive: "trives",
    present: "trives",
    past: "trivdes",
    present_perfect: "har trives",
    english: "enjoy, thrive",
  },
  tro: {
    infinitive: "tro",
    present: "tror",
    past: "trodde",
    present_perfect: "har trodd",
    english: "believe",
  },
  tvile: {
    infinitive: "tvile",
    present: "tviler",
    past: "tvilte",
    present_perfect: "har tvilt",
    english: "doubt",
  },
  tvinge: {
    infinitive: "tvinge",
    present: "tvinger",
    past: "tvang",
    present_perfect: "har tvunget",
    english: "force",
  },
  velge: {
    infinitive: "velge",
    present: "velger",
    past: "valgte",
    present_perfect: "har valgt",
    english: "choose, elect",
  },
  vente: {
    infinitive: "vente",
    present: "venter",
    past: "ventet",
    present_perfect: "har ventet",
    english: "wait, expect",
  },
  ville: {
    infinitive: "ville",
    present: "vil",
    past: "ville",
    present_perfect: "har villet",
    english: "want to, will",
  },
  vinne: {
    infinitive: "vinne",
    present: "vinner",
    past: "vant",
    present_perfect: "har vunnet",
    english: "win, gain",
  },
  vise: {
    infinitive: "vise",
    present: "viser",
    past: "viste",
    present_perfect: "har vist",
    english: "show",
  },
  vite: {
    infinitive: "vite",
    present: "vet",
    past: "visste",
    present_perfect: "har visst",
    english: "know (fact)",
  },
  være: {
    infinitive: "være",
    present: "er",
    past: "var",
    present_perfect: "har vært",
    english: "be, exist",
  },
  ønske: {
    infinitive: "ønske",
    present: "ønsker",
    past: "ønsket, ønska",
    present_perfect: "har ønsket, har ønska",
    english: "wish, desire",
  },
  åpne: {
    infinitive: "åpne",
    present: "åpner",
    past: "åpnet, åpna",
    present_perfect: "har åpnet, har åpna",
    english: "open",
  },
};
